import React, { useMemo } from 'react'
import { SunIcon } from 'src/Libs/flow/icons'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { localizeEmobilityNumber } from '../utils/localize-emobility-number'
import { Card } from './Card'

interface SolarRatioCardProps {
  totalGridEnergyKWh: number
  totalSolarEnergyKWh: number
}

/** The component shows the share of solar energy from the total energy */
export const SolarRatioCard: React.FC<SolarRatioCardProps> = ({ totalGridEnergyKWh, totalSolarEnergyKWh }) => {
  const { t } = useCustomTranslation()

  const positiveTotalGridEnergyKWh = Math.max(0, totalGridEnergyKWh)

  const solarRatio = useMemo(() => {
    if (totalSolarEnergyKWh === 0) return 0
    if (positiveTotalGridEnergyKWh + totalSolarEnergyKWh === 0) return 0
    return (totalSolarEnergyKWh * 100) / (positiveTotalGridEnergyKWh + totalSolarEnergyKWh)
  }, [positiveTotalGridEnergyKWh, totalSolarEnergyKWh])

  return (
    <Card
      Icon={SunIcon}
      label={t('emobility.chargingSession.solarRatio')}
      value={t('common.format.percentageValue', '', { value: localizeEmobilityNumber(solarRatio) })}
    />
  )
}
